import Cookies from 'js-cookie';

export const sessionListener = async () => {
    const SESSION_COOKIE_NAME = 'is_customer_logged';

    const token = Cookies.get(SESSION_COOKIE_NAME);

    if (token) {
        window.dispatchEvent(new CustomEvent('session.exists', { detail: { token } }));
    }
};
